export abstract class ResultValue {
  static ok<T>(apiResult: ApiResult<T>): apiResult is ApiOKResult<T> {
    return (apiResult as ApiOKResult<T>).ok === true;
  }

  static error<T>(apiResult: ApiResult<T>): apiResult is ApiErrorResult {
    return (apiResult as ApiErrorResult).ok === false;
  }
}

export type ApiResult<T> = ApiErrorResult | ApiOKResult<T>;

export interface ApiOKResult<T> {
  ok: true;
  data: T;
  message: string;
}

export interface ApiErrorResult {
  ok: false;
  message: string;
  errorCode?: string;
}
